import request from "axios"

const instance = request.create({
    timeout: 1000 * 10
})

// 添加请求拦截器 <==> 请求发起前做的事
instance.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.resolve(error)
    }
)

// 添加响应拦截器 <==> 响应回来后做的事
instance.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        if (error.response) {
            return Promise.resolve(error.response.data)
        } else {
            return Promise.resolve({ code: "400", msg: "未知错误，请联系管理员", data: null })
        }
    }
)

const get = (url, params) => instance.get(url, { params })
const post = (url, params) => instance.post(url, params)

/**
 * 获取上传权限
 * 参数
 *     md5
 *     size
 *     ext
 *     图片 ? img: 1
 */
 export const getUploadAuth = params => get("https://api.artron.net/v1/upload/auth", params)

/**
 * 验证上传文件
 * 参数
 *     md5
 *     size
 *     ext
 *     auth
 *     sourceType 3(图片)
 *     图片 ? img: 1
 */
export const uploadFileCheck = params => get("https://upload-video.artron.net/appFile/filecheck", params)

/**
 * 上传文件
 * 参数
 *     md5          文件唯一值
 *     ext          文件类型
 *     sourceType   业务来源
 *     size         文件大小
 *     auth         加密值
 *     chunk        当前切片
 *     chunks       总切片数
 *     file         文件
 */
export const uploadFile = params => post("https://upload-video.artron.net/appFile/upload", params)

/**
 * 合并切片
 * 参数
 *     md5         文件md5
 *     auth        身份验证
 *     ext         文件扩展名
 *     sourceType  业务类型
 *     size        文件大小
 *     chunks      切片数量
 */
export const uploadFileMerge = params => post("https://upload-video.artron.net/appFile/chunksmerge", params)
